import { useCallback, useState } from 'react';
import { HStack, Link, Text } from '@direct-frontend/components';
import { Checkbox } from '@/shared/components/Checkbox';
import { DrawerButton } from '@/shared/components/Drawer';
import { useAnimation } from '@/shared/lib/hooks';
import styles from './LoyaltyRegistrationButton.module.css';

interface LoyaltyRegistrationButtonProps {
    loyaltyProgramUrl: string;
    onRegister: VoidFunction;
    isLoading: boolean;
}

export const LoyaltyRegistrationButton = (props: LoyaltyRegistrationButtonProps) => {
    const { loyaltyProgramUrl, isLoading, onRegister } = props;

    const [checked, setChecked] = useState<boolean>(false);
    const [checkInvalid, setCheckInvalid] = useState(false);

    const { ref, triggerAnimation } = useAnimation({ type: 'shake' });

    const handleRegister = useCallback(() => {
        if (!checked) {
            triggerAnimation();
            setCheckInvalid(true);

            return;
        }

        onRegister();
    }, [checked, onRegister, triggerAnimation]);

    return (
        <>
            <DrawerButton isDisabled={isLoading} onClick={handleRegister}>
                Зарегистрироваться
            </DrawerButton>

            <HStack ref={ref} as="span" gap="8" justifyContent="center">
                <Checkbox
                    checked={checked}
                    invalid={checkInvalid}
                    onClick={() => {
                        setChecked(!checked);
                        setCheckInvalid(false);
                    }}
                    label={
                        <HStack as="span" alignItems="center" flexWrap="wrap">
                            <Text color={checkInvalid ? 'red' : 'current'} className={styles.labelText}>
                                Соглашаюсь с&nbsp;
                            </Text>
                            <Text className={styles.labelText}>
                                <Link className={styles.link} color="main" href={loyaltyProgramUrl} target="_blank">
                                    условиями программы лояльности
                                </Link>
                            </Text>
                        </HStack>
                    }
                />
            </HStack>
        </>
    );
};
